// Client error responses
class BadRequest extends Error {
  constructor() {
    super();
    this.message = 'Bad Request';
    this.name = 'BadRequest';
  }
}
class Unauthorised extends Error {
  constructor() {
    super();
    this.message = 'Unauthorised';
    this.name = 'Unauthorised';
  }
}
class PaymentRequired extends Error {
  constructor() {
    super();
    this.message = 'Payment Required';
    this.name = 'PaymentRequired';
  }
}
class Forbidden extends Error {
  constructor() {
    super();
    this.message = 'Forbidden';
    this.name = 'Forbidden';
  }
}
class NotFound extends Error {
  constructor() {
    super();
    this.message = 'Not Found';
    this.name = 'NotFound';
  }
}
class MethodNotAllowed extends Error {
  constructor() {
    super();
    this.message = 'Method Not Allowed';
    this.name = 'MethodNotAllowed';
  }
}
class NotAcceptable extends Error {
  constructor() {
    super();
    this.message = 'Not Acceptable';
    this.name = 'NotAcceptable';
  }
}
class RequestTimeout extends Error {
  constructor() {
    super();
    this.message = 'Request Timeout';
    this.name = 'RequestTimeout';
  }
}
class LengthRequired extends Error {
  constructor() {
    super();
    this.message = 'Length Required';
    this.name = 'LengthRequired';
  }
}
class TooManyRequests extends Error {
  constructor() {
    super();
    this.message = 'Too Many Requests';
    this.name = 'TooManyRequests';
  }
}
class RequestHeaderFieldsTooLarge extends Error {
  constructor() {
    super();
    this.message = 'Request Header Fields Too Large';
    this.name = 'RequestHeaderFieldsTooLarge';
  }
}

// Server error responses
class InternalServerError extends Error {
  constructor() {
    super();
    this.message = 'Internal Server Error';
    this.name = 'InternalServerError';
  }
}
class NotImplemented extends Error {
  constructor() {
    super();
    this.message = 'Not Implemented';
    this.name = 'NotImplemented';
  }
}
class BadGateway extends Error {
  constructor() {
    super();
    this.message = 'Bad Gateway';
    this.name = 'BadGateway';
  }
}
class ServiceUnavailable extends Error {
  constructor() {
    super();
    this.message = 'Service Unavailable';
    this.name = 'ServiceUnavailable';
  }
}
class GatewayTimeout extends Error {
  constructor() {
    super();
    this.message = 'Gateway Timeout';
    this.name = 'GatewayTimeout';
  }
}
class HTTPVersionNotSupported extends Error {
  constructor() {
    super();
    this.message = 'HTTP Version Not Supported';
    this.name = 'HTTPVersionNotSupported';
  }
}
class NetworkAuthenticationRequired extends Error {
  constructor() {
    super();
    this.message = 'Network Authentication Required';
    this.name = 'NetworkAuthenticationRequired';
  }
}

// General Error
class SomethingGoneWrong extends Error {
  constructor() {
    super();
    this.message = 'Something Gone Wrong';
    this.name = 'SomethingGoneWrong';
  }
}

export default {
  BadRequest,
  Unauthorised,
  PaymentRequired,
  Forbidden,
  NotFound,
  MethodNotAllowed,
  NotAcceptable,
  RequestTimeout,
  LengthRequired,
  TooManyRequests,
  RequestHeaderFieldsTooLarge,
  InternalServerError,
  NotImplemented,
  BadGateway,
  ServiceUnavailable,
  GatewayTimeout,
  HTTPVersionNotSupported,
  NetworkAuthenticationRequired,
  SomethingGoneWrong,
};
